import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { createAction, createReducer, on, props } from '@ngrx/store';
import { AttendanceRecord } from 'app/models';
import { AttendanceRecordState } from './attendance.state';

export enum AttendanceActionTypes {
	GetSessionAttendance = '[Attendance] Get Session Attendance',
	UpdateAttendanceRecord = '[Attendance] Update Student Attendance',
}

export const GetSessionAttendanceAction = createAction(AttendanceActionTypes.GetSessionAttendance, props<{ records: AttendanceRecord[] }>());
export const UpdateAttendanceRecordAction = createAction(AttendanceActionTypes.UpdateAttendanceRecord, props<{ record: AttendanceRecord }>());

const initialState: AttendanceRecordState = {
	ids: [],
	entities: {},
};

export const attendanceAdapter: EntityAdapter<AttendanceRecord> = createEntityAdapter<AttendanceRecord>();

export const attendanceReducer = createReducer(
	initialState,

	on(GetSessionAttendanceAction, (state, { records }) => {
		if (records) {
			return attendanceAdapter.upsertMany(records, state);
		}
		return state;
	}),
	on(UpdateAttendanceRecordAction, (state, { record }) => {
		if (record) {
			return attendanceAdapter.upsertOne(record, state);
		}
		return state;
	})
);
